export interface ServiceConfig {
	NEW_FELT_URL: string;
	SLOTS_URL: string;
	SLOTS_API_URL: string;
	SLOTS_EXTERNAL_API_URL: string;
	GAME_SERVER_SOCKET_URL: string;
	LANDING_PAGE_URL: string;
	GC_LANDING_PAGE_URL: string;
	SHARE_HAND_URL: string;
	REDEMPTIONS_HUB_BASE_URL: string;
	LOBBY_API_SERVICE: string;
	USERAPI_BASE_URL: string;
	STORE_URL: string;
	PROFILE_SERVICE_BASE_URL: string;
	BLACKJACK_URL: string;
	BLACKJACK_HAND_HISTORY_URL: string;
	PLAYER_NOTIFICATIONS_URL: string;
	PLAYER_ACCOUNT_BASE_URL: string;
	CUSTOMER_DUE_DILIGENCE_URL: string;
	GAMIFICATION_URL: string;
	CASINO_MANAGEMENT_URL: string;
	POKER_SERVER_SIT_AND_GO_URL: string;
	POKER_SERVER_JSNG_URL: string;
	POKER_SERVER_SCHEDULED_TOURNAMENT_URL: string;
	POK_USER_API_URL: string;
	POKER_TABLE_URL: string;
	SOURCE_OF_WEALTH_FORM_URL: string;
	GLOBAL_POKER_ZENDESK_URL: string;
	GLOBAL_POKER_HELPDESK_URL: string;
	BRAZE_SDK_API_KEY: string;
	BRAZE_SDK_URL: string;
	POKER_LOBBY_API_URL: string;
	POKER_LOBBY_WEB_SOCKET_URL: string;
	POKER_SERVER_RING_GAMES_URL: string;
	POKER_TABLE_GATEWAY_URL: string;
	GAP_API_URL: string;
	RMP_PROFILING_SCRIPT_URL: string;
	RMP_RISK_ASSESSMENT_KEY: string;
	LEADERBOARD_HAND_REPLAY_URL: string;
	GEOCOMPLY_SDK_URL: string;
}

export const localServiceConfig: ServiceConfig = {
	NEW_FELT_URL: 'http://localhost:8181/gameplay/index.html',
	SLOTS_URL: 'https://slots.ci.test.globalpoker.com',
	SLOTS_API_URL: 'https://slots-server.ci.test.globalpoker.com',
	SLOTS_EXTERNAL_API_URL: 'https://slots-server-external.ci.test.globalpoker.com',
	GAME_SERVER_SOCKET_URL: 'ws://localhost:8282/socket',
	LANDING_PAGE_URL: 'http://localhost:8080',
	GC_LANDING_PAGE_URL: 'http://localhost:8080',
	SHARE_HAND_URL: 'http://localhost:8080/gp/10/hand/{sharedHandId}',
	REDEMPTIONS_HUB_BASE_URL: '',
	LOBBY_API_SERVICE: 'http://localhost:8888',
	USERAPI_BASE_URL: 'http://localhost:8383/rest',
	STORE_URL: 'http://localhost:8088',
	PROFILE_SERVICE_BASE_URL: 'http://localhost:8087',
	BLACKJACK_URL: 'http://localhost:3000',
	BLACKJACK_HAND_HISTORY_URL: 'http://localhost:3001',
	PLAYER_NOTIFICATIONS_URL: 'https://player-notifications.ci.test.globalpoker.com',
	PLAYER_ACCOUNT_BASE_URL: 'http://localhost:10998',
	CUSTOMER_DUE_DILIGENCE_URL: `https://customer-due-diligence.ci.test.globalpoker.com`,
	GAMIFICATION_URL: 'http://localhost:10999',
	CASINO_MANAGEMENT_URL: 'https://casino-management.ci.test.globalpoker.com',
	POKER_SERVER_SIT_AND_GO_URL: 'http://localhost:10004',
	POKER_SERVER_JSNG_URL: 'http://localhost:10020',
	POKER_SERVER_SCHEDULED_TOURNAMENT_URL: 'http://localhost:10009',
	POK_USER_API_URL: 'http://localhost:8080',
	POKER_TABLE_URL: 'http://localhost:10011',
	SOURCE_OF_WEALTH_FORM_URL: 'https://vgw.qualtrics.com/jfe/form/SV_4ZTpR0kmSX3Ip8y',
	GLOBAL_POKER_ZENDESK_URL: 'https://globalpoker.zendesk.com',
	GLOBAL_POKER_HELPDESK_URL: 'https://vgw--develop.sandbox.my.site.com/pok',
	BRAZE_SDK_API_KEY: '',
	BRAZE_SDK_URL: 'sdk.iad-01.braze.com',
	POKER_LOBBY_API_URL: 'http://localhost:10005',
	POKER_LOBBY_WEB_SOCKET_URL: 'ws://localhost:10005',
	POKER_SERVER_RING_GAMES_URL: 'http://localhost:10007',
	POKER_TABLE_GATEWAY_URL: 'http://localhost:10008',
	GAP_API_URL: 'https://api.gap-dev.vgwgames.com',
	RMP_PROFILING_SCRIPT_URL: 'https://payments.test.vgwgroup.net/rmp/aps',
	RMP_RISK_ASSESSMENT_KEY: 'eyJ0ZW5hbnQiOiJwb2stZGV2IiwiZG9tYWluIjoyfQ==',
	LEADERBOARD_HAND_REPLAY_URL: 'http://localhost:8080/leaderboard/entry/{leaderboardEntryId}/hand',
	GEOCOMPLY_SDK_URL: 'https://payments.dev.vgwgroup.net/rmp/location/sdk',
}

export const ciServiceConfig: ServiceConfig = {
	NEW_FELT_URL: '/gameplay/index.html',
	SLOTS_URL: 'https://slots.ci.test.globalpoker.com',
	SLOTS_API_URL: 'https://slots-server.ci.test.globalpoker.com',
	SLOTS_EXTERNAL_API_URL: 'https://slots-server-external.ci.test.globalpoker.com',
	GAME_SERVER_SOCKET_URL: 'wss://game-devk.dev.globalpoker.com/socket',
	LANDING_PAGE_URL: 'https://mardev.globalpoker.com',
	GC_LANDING_PAGE_URL: 'https://ci.test.globalcasino.com',
	SHARE_HAND_URL: 'https://play.ci.test.globalpoker.com/gp/10/hand/{sharedHandId}',
	REDEMPTIONS_HUB_BASE_URL: 'https://redemptions.ci.test.globalpoker.com/redemption',
	LOBBY_API_SERVICE: 'https://lobby.ci.test.globalpoker.com',
	USERAPI_BASE_URL: 'https://usersite.ci.test.globalpoker.com/rest',
	STORE_URL: 'https://store.ci.test.globalpoker.com',
	PROFILE_SERVICE_BASE_URL: 'https://player-profile.ci.test.globalpoker.com',
	BLACKJACK_URL: 'https://blackjack.ci.test.globalpoker.com',
	BLACKJACK_HAND_HISTORY_URL: 'https://blackjack-server.ci.test.globalpoker.com',
	PLAYER_NOTIFICATIONS_URL: 'https://player-notifications.ci.test.globalpoker.com',
	PLAYER_ACCOUNT_BASE_URL: 'https://player-account-web-api.ci.test.globalpoker.com',
	CUSTOMER_DUE_DILIGENCE_URL: `https://customer-due-diligence.ci.test.globalpoker.com`,
	GAMIFICATION_URL: 'https://gamification.ci.test.globalpoker.com',
	CASINO_MANAGEMENT_URL: 'https://casino-management.ci.test.globalpoker.com',
	POKER_SERVER_SIT_AND_GO_URL: 'https://tournament.ci.test.globalpoker.com',
	POKER_SERVER_JSNG_URL: 'https://jsng.ci.test.globalpoker.com',
	POKER_SERVER_SCHEDULED_TOURNAMENT_URL: 'https://scheduled-tournament.ci.test.globalpoker.com',
	POK_USER_API_URL: 'https://user.ci.test.globalpoker.com',
	POKER_TABLE_URL: 'https://poker-table.ci.test.globalpoker.com',
	SOURCE_OF_WEALTH_FORM_URL: 'https://vgw.qualtrics.com/jfe/form/SV_4ZTpR0kmSX3Ip8y',
	GLOBAL_POKER_ZENDESK_URL: 'https://globalpoker.zendesk.com',
	GLOBAL_POKER_HELPDESK_URL: 'https://vgw--develop.sandbox.my.site.com/pok',
	BRAZE_SDK_API_KEY: '',
	BRAZE_SDK_URL: 'sdk.iad-01.braze.com',
	POKER_LOBBY_API_URL: 'https://poker-lobby.ci.test.globalpoker.com',
	POKER_LOBBY_WEB_SOCKET_URL: 'wss://poker-lobby.ci.test.globalpoker.com',
	POKER_SERVER_RING_GAMES_URL: 'https://ring-game.ci.test.globalpoker.com',
	POKER_TABLE_GATEWAY_URL: 'https://poker-table-gateway.ci.test.globalpoker.com',
	GAP_API_URL: 'https://api.gap-dev.vgwgames.com',
	RMP_PROFILING_SCRIPT_URL: 'https://payments.test.vgwgroup.net/rmp/aps',
	RMP_RISK_ASSESSMENT_KEY: 'eyJ0ZW5hbnQiOiJwb2stZGV2IiwiZG9tYWluIjoyfQ==',
	LEADERBOARD_HAND_REPLAY_URL: 'https://play.ci.test.globalpoker.com/leaderboard/entry/{leaderboardEntryId}/hand',
	GEOCOMPLY_SDK_URL: 'https://payments.test.vgwgroup.net/rmp/location/sdk',
}

export const qcServiceConfig: ServiceConfig = {
	NEW_FELT_URL: '/gameplay/index.html',
	SLOTS_URL: 'https://slots.qc.test.globalpoker.com',
	SLOTS_API_URL: 'https://slots-server.qc.test.globalpoker.com',
	SLOTS_EXTERNAL_API_URL: 'https://slots-server-external.qc.test.globalpoker.com',
	GAME_SERVER_SOCKET_URL: 'wss://game-testa.dev.globalpoker.com/socket',
	LANDING_PAGE_URL: 'https://test.globalpoker.com',
	GC_LANDING_PAGE_URL: 'https://qc.test.globalcasino.com',
	SHARE_HAND_URL: 'https://play.qc.test.globalpoker.com/gp/10/hand/{sharedHandId}',
	REDEMPTIONS_HUB_BASE_URL: 'https://redemptions.qc.test.globalpoker.com/redemption',
	LOBBY_API_SERVICE: 'https://lobby.qc.test.globalpoker.com',
	USERAPI_BASE_URL: 'https://usersite.qc.test.globalpoker.com/rest',
	STORE_URL: 'https://store.qc.test.globalpoker.com',
	PROFILE_SERVICE_BASE_URL: 'https://player-profile.qc.test.globalpoker.com',
	BLACKJACK_URL: 'https://blackjack.qc.test.globalpoker.com',
	BLACKJACK_HAND_HISTORY_URL: 'https://blackjack-server.qc.test.globalpoker.com',
	PLAYER_NOTIFICATIONS_URL: 'https://player-notifications.qc.test.globalpoker.com',
	PLAYER_ACCOUNT_BASE_URL: 'https://player-account-web-api.qc.test.globalpoker.com',
	CUSTOMER_DUE_DILIGENCE_URL: `https://customer-due-diligence.qc.test.globalpoker.com`,
	GAMIFICATION_URL: 'https://gamification.qc.test.globalpoker.com',
	CASINO_MANAGEMENT_URL: 'https://casino-management.qc.test.globalpoker.com',
	POKER_SERVER_SIT_AND_GO_URL: 'https://tournament.qc.test.globalpoker.com',
	POKER_SERVER_JSNG_URL: 'https://jsng.qc.test.globalpoker.com',
	POKER_SERVER_SCHEDULED_TOURNAMENT_URL: 'https://scheduled-tournament.qc.test.globalpoker.com',
	POK_USER_API_URL: 'https://user.qc.test.globalpoker.com',
	POKER_TABLE_URL: 'https://poker-table.qc.test.globalpoker.com',
	SOURCE_OF_WEALTH_FORM_URL: 'https://vgw.qualtrics.com/jfe/form/SV_4ZTpR0kmSX3Ip8y',
	GLOBAL_POKER_ZENDESK_URL: 'https://globalpoker.zendesk.com',
	GLOBAL_POKER_HELPDESK_URL: 'https://vgw--stage.sandbox.my.site.com/pok',
	BRAZE_SDK_API_KEY: 'e5aa758b-9977-4197-9958-3c5a00c4f0cf',
	BRAZE_SDK_URL: 'sdk.iad-01.braze.com',
	POKER_LOBBY_API_URL: 'https://poker-lobby.qc.test.globalpoker.com',
	POKER_LOBBY_WEB_SOCKET_URL: 'wss://poker-lobby.qc.test.globalpoker.com',
	POKER_SERVER_RING_GAMES_URL: 'https://ring-game.qc.test.globalpoker.com',
	POKER_TABLE_GATEWAY_URL: 'https://poker-table-gateway.qc.test.globalpoker.com',
	GAP_API_URL: 'https://api.gap-test.vgwgames.com',
	RMP_PROFILING_SCRIPT_URL: 'https://payments.test.vgwgroup.net/rmp/aps',
	RMP_RISK_ASSESSMENT_KEY: 'eyJ0ZW5hbnQiOiJwb2stdGVzdCIsImRvbWFpbiI6Mn0=',
	LEADERBOARD_HAND_REPLAY_URL: 'https://play.qc.test.globalpoker.com/leaderboard/entry/{leaderboardEntryId}/hand',
	GEOCOMPLY_SDK_URL: 'https://payments.test.vgwgroup.net/rmp/location/sdk',
}

export const prodServiceConfig: ServiceConfig = {
	NEW_FELT_URL: '/gameplay/index.html',
	SLOTS_URL: 'https://slots.globalpoker.com',
	SLOTS_API_URL: 'https://slots-server.globalpoker.com',
	SLOTS_EXTERNAL_API_URL: 'https://slots-server-external.globalpoker.com',
	GAME_SERVER_SOCKET_URL: 'wss://game.globalpoker.com/socket',
	LANDING_PAGE_URL: 'https://globalpoker.com',
	GC_LANDING_PAGE_URL: 'https://globalcasino.com',
	SHARE_HAND_URL: 'https://play.globalpoker.com/gp/10/hand/{sharedHandId}',
	REDEMPTIONS_HUB_BASE_URL: 'https://redemptions.globalpoker.com/redemption',
	LOBBY_API_SERVICE: 'https://lobby.globalpoker.com',
	USERAPI_BASE_URL: 'https://usersite.globalpoker.com/rest',
	STORE_URL: 'https://store.globalpoker.com',
	PROFILE_SERVICE_BASE_URL: 'https://player-profile.globalpoker.com',
	BLACKJACK_URL: 'https://blackjack.globalpoker.com',
	BLACKJACK_HAND_HISTORY_URL: 'https://blackjack-server.globalpoker.com',
	PLAYER_NOTIFICATIONS_URL: 'https://player-notifications.globalpoker.com',
	PLAYER_ACCOUNT_BASE_URL: 'https://player-account-web-api.globalpoker.com',
	CUSTOMER_DUE_DILIGENCE_URL: `https://customer-due-diligence.globalpoker.com`,
	GAMIFICATION_URL: 'https://gamification.globalpoker.com',
	CASINO_MANAGEMENT_URL: 'https://casino-management.globalpoker.com',
	POKER_SERVER_SIT_AND_GO_URL: 'https://tournament.globalpoker.com',
	POKER_SERVER_JSNG_URL: 'https://jsng.globalpoker.com',
	POKER_SERVER_SCHEDULED_TOURNAMENT_URL: 'https://scheduled-tournament.globalpoker.com',
	POK_USER_API_URL: 'https://user.globalpoker.com',
	POKER_TABLE_URL: 'https://poker-table.globalpoker.com',
	SOURCE_OF_WEALTH_FORM_URL: 'https://vgw.qualtrics.com/jfe/form/SV_4ZTpR0kmSX3Ip8y',
	GLOBAL_POKER_ZENDESK_URL: 'https://globalpoker.zendesk.com',
	GLOBAL_POKER_HELPDESK_URL: 'https://help.globalpoker.com',
	BRAZE_SDK_API_KEY: '360d8ff6-f8f9-4bc0-bf3a-ec63ab1cecbc',
	BRAZE_SDK_URL: 'sdk.iad-01.braze.com',
	POKER_LOBBY_API_URL: 'https://poker-lobby.globalpoker.com',
	POKER_LOBBY_WEB_SOCKET_URL: 'wss://poker-lobby.globalpoker.com',
	POKER_SERVER_RING_GAMES_URL: 'https://ring-game.globalpoker.com',
	POKER_TABLE_GATEWAY_URL: 'https://poker-table-gateway.globalpoker.com',
	GAP_API_URL: 'https://api.gap.vgwgames.com',
	RMP_PROFILING_SCRIPT_URL: 'https://payments.vgwgroup.net/rmp/aps',
	RMP_RISK_ASSESSMENT_KEY: 'eyJ0ZW5hbnQiOiJwb2stcHJvZCIsImRvbWFpbiI6Mn0=',
	LEADERBOARD_HAND_REPLAY_URL: 'https://play.globalpoker.com/leaderboard/entry/{leaderboardEntryId}/hand',
	GEOCOMPLY_SDK_URL: 'https://payments.vgwgroup.net/rmp/location/sdk',
}
